import { ButtonProps, Popconfirm, PopconfirmProps } from "antd";
import { EditButton } from "./EditButton";
import { useTranslate } from "#src/hooks";

export const ChangeAssetButton = ({
  popConfirmProps,
  buttonItem,
  ...props
}: ButtonProps & {
  popConfirmProps: PopconfirmProps;
  buttonItem: string;
}) => {
  const t = useTranslate();
  return (
    <Popconfirm
      okText={t("buttons.continue")}
      cancelText={t("buttons.cancel")}
      getPopupContainer={(triggerNode) => triggerNode.parentElement}
      styles={{
        root: {
          maxWidth: "100%",
        },
      }}
      {...popConfirmProps}
    >
      <EditButton item={buttonItem.toLowerCase()} {...props} />
    </Popconfirm>
  );
};
